import { toJS } from 'mobx';

import type {
  InteractiveQuestionAnswerPayload,
  PlayerUserAnswer,
} from '@genially/p2p-lib';
import { isPlayerUserAnswerScoreable } from '@genially/p2p-lib';

export const toRestorableAnswer = (
  playerUserAnswer: PlayerUserAnswer,
): InteractiveQuestionAnswerPayload => {
  // `playerUserAnswer.answer` is still a mobx(-keystone) observable here (`asJS` only unwraps the
  // model itself, not its props) — convert it to a plain value before it's returned or spread
  // below, or a still-observable `answerIds` inside it throws `DataCloneError` the moment it's
  // sent over `postMessage`. Converting `playerUserAnswer` as a whole instead (e.g. spreading it
  // at the call site) breaks `PlayerUserAnswer`'s discriminated union between `answer`'s variant
  // and the rest, so it has to happen on `answer` alone, here.
  const answer = toJS(playerUserAnswer.answer);

  if (
    answer.bankInteractiveQuestionId === undefined ||
    !isPlayerUserAnswerScoreable(playerUserAnswer)
  ) {
    return answer;
  }

  return { ...answer, isCorrect: playerUserAnswer.isCorrect };
};
